import Vue from "vue";
import Flash from './components/Flash/flash.vue';
import Reservations from './components/reservations.vue';
import ReservationsNew from './components/Booking/ReservationsNew.vue';
import ModalReservations from './components/Booking/ModalReservations.vue';
import ModalLoginOrRegister from './components/Booking/ModalLoginOrRegister.vue';
import Payment from './components/payment.vue';
import PresaleCoupons from './components/presaleCoupons.vue';
import Communication from './components/Communication/communication.vue';
import CustomerDash from './components/Dashboard/Customer/CustomerDash.vue';
import CustomerDashModalCancelBooking from './components/Dashboard/Customer/CustomerDashModalCancelBooking.vue';
import CustomerCreateDashComponent from './components/Dashboard/Customer/CustomerCreateDashComponent.vue';
import CustomerDashCoupons from './components/Dashboard/Customer/CustomerDashCoupons.vue';
import CustomerDashIntro from './components/Dashboard/Customer/CustomerDashIntro.vue';
import CustomerDashLocations from './components/Dashboard/Customer/CustomerDashLocations.vue';
import CustomerDashBookings from './components/Dashboard/Customer/CustomerDashBookings.vue';
import CustomerDashModalPrelimCancellationInfo from './components/Dashboard/Customer/CustomerDashModalPrelimCancellationInfo.vue';
import CustomerDashOutro from './components/Dashboard/Customer/CustomerDashOutro.vue';
import CustomerDashQueue from './components/Dashboard/Customer/CustomerDashQueue.vue';
import AdminDash from './components/Dashboard/Admin/AdminDash.vue';
import AdminCreateDashComponent from './components/Dashboard/Admin/AdminCreateDashComponent.vue';
import AdminDashIntro from './components/Dashboard/Admin/AdminDashIntro.vue';
import AdminDashCoupons from './components/Dashboard/Admin/AdminDashCoupons.vue';
import AdminDashOccupancy from './components/Dashboard/Admin/AdminDashOccupancy.vue';
import AdminDashOccupancyGraph from './components/Dashboard/Admin/AdminDashOccupancyGraph.vue';
import AdminDashBookingsGraph from './components/Dashboard/Admin/AdminDashBookingsGraph.vue';
import AdminDashRevenue from './components/Dashboard/Admin/AdminDashRevenue.vue';
import AdminDashRevenueGraph from './components/Dashboard/Admin/AdminDashRevenueGraph';
import AdminDashEventsPanel from './components/Dashboard/Admin/AdminDashEventsPanel';
import TherapistDash from './components/Dashboard/Therapist/TherapistDash.vue';
import TherapistCreateDashComponent from './components/Dashboard/Therapist/TherapistCreateDashComponent.vue';
import TherapistDashSchedule from './components/Dashboard/Therapist/TherapistDashSchedule.vue';
import TherapistDashScheduleNew from './components/Dashboard/Therapist/TherapistDashScheduleNew.vue';
import TherapistDashScheduleTable from './components/Dashboard/Therapist/TherapistDashScheduleTable.vue';
import TherapistDashIntro from './components/Dashboard/Therapist/TherapistDashIntro.vue';
import TherapistDashWeeklySchedule from './components/Dashboard/Therapist/TherapistDashWeeklySchedule.vue';
import TherapistDashExpendituresList from './components/Dashboard/Therapist/TherapistDashExpendituresList.vue';
import CompanyOfficialDash from './components/Dashboard/CompanyOfficial/CompanyOfficialDash.vue';
import TherapistDashModalLock from './components/Dashboard/Therapist/TherapistDashModalLock.vue';
import TherapistDashModalLockMonth from './components/Dashboard/Therapist/TherapistDashModalLockMonth.vue';
import TherapistDashModalCustomerAbsent from './components/Dashboard/Therapist/TherapistDashModalCustomerAbsent.vue';
import TherapistDashModalCustomerPresent from './components/Dashboard/Therapist/TherapistDashModalCustomerPresent.vue';
import TherapistDashModalDeleteBooking from './components/Dashboard/Therapist/TherapistDashModalDeleteBooking.vue';
import TherapistDashModalRemoveDay from './components/Dashboard/Therapist/TherapistDashModalRemoveDay.vue';
import TherapistDashModalAddSchedule from './components/Dashboard/Therapist/TherapistDashModalAddSchedule.vue';
import TherapistDashModalManualBooking from './components/Dashboard/Therapist/TherapistDashModalManualBooking.vue';
import TherapistDashModalAddExpenditure from './components/Dashboard/Therapist/TherapistDashModalAddExpenditure.vue';
import TherapistDashModalDeleteExpenditure from './components/Dashboard/Therapist/TherapistDashModalDeleteExpenditure.vue';
import TherapistDashModalAddAdministrativeTime from "./components/Dashboard/Therapist/TherapistDashModalAddAdministrativeTime";
import TherapistDashAdminTimeList from "./components/Dashboard/Therapist/TherapistAdminTimeList"
import TherapistDashModalDeleteAdminTime from "./components/Dashboard/Therapist/TherapistDashModalDeleteAdminTime";
import Availability from './components/Availability/Availability.vue';
import SimpleWeeklySchedule from './components/SimpleWeeklySchedule/SimpleWeeklySchedule.vue';
import SimpleWeeklyScheduleDay from './components/SimpleWeeklySchedule/SimpleWeeklyScheduleDay.vue';
import SimpleWeeklySchedulePost from './components/SimpleWeeklySchedule/SimpleWeeklySchedulePost.vue';
import SimpleWeeklyScheduleTime from './components/SimpleWeeklySchedule/SimpleWeeklyScheduleTime.vue';
import AdminCalendar from './components/AdminCalendar/AdminCalendar.vue';
import AdminSchedules from './components/AdminSchedules/AdminSchedules.vue';
import AdminDashNews from './components/Dashboard/Admin/AdminDashNews';
import Booking from './components/Booking/Booking.vue';
import BookingNew from './components/Booking/BookingNew.vue';
import DoubleBooking from './components/Booking/DoubleBooking.vue';
import BookingModal from './components/Booking/BookingModal.vue';
import Calendar from './components/Calendar/Calendar.vue';
import CalendarDay from './components/Calendar/CalendarDay.vue';
import TransEdit from './components/transedit/TransEdit.vue';
import RedDays from './components/RedDay/Table';
import TherapistDashReports from './components/Dashboard/Therapist/TherapistDashReports';
import AdminSchedulesModalUnbook from './components/AdminSchedules/AdminSchedulesModalUnbook';
import AdminSchedulesModalCustomerAbsent from "./components/AdminSchedules/AdminSchedulesModalCustomerAbsent";
import AdminSchedulesModalCustomerPresent from "./components/AdminSchedules/AdminSchedulesModalCustomerPresent";
import AdminSchedulesModalRemoveDay from "./components/AdminSchedules/AdminSchedulesModalRemoveDay";
import AdminSchedulesModalAddSchedule from "./components/AdminSchedules/AdminSchedulesModalAddSchedule";
import AdminSchedulesModalSubstitute from "./components/AdminSchedules/AdminSchedulesModalSubstitute";
import AdminSchedulesModalBook from "./components/AdminSchedules/AdminSchedulesModalBook";
import AdminSchedulesModalAbsence from "./components/AdminSchedules/AdminSchedulesModalAbsence";
import AdminSchedulesBatchModalChangeLocation from "./components/AdminSchedules/AdminSchedulesBatchModalChangeLocation";
import AdminSchedulesBatchModalChangePeriod from "./components/AdminSchedules/AdminSchedulesBatchModalChangePeriod";
import AdminSchedulesBatchModalChangeTherapist from "./components/AdminSchedules/AdminSchedulesBatchModalChangeTherapist";
import AdminSchedulesBatchModalChangeWeekdays from "./components/AdminSchedules/AdminSchedulesBatchModalChangeWeekdays";
import AdminSchedulesModalDeleteSchedule from "./components/AdminSchedules/AdminSchedulesModalDeleteSchedule";
import AbsenceForm from "./components/Absence/AbsenceForm.vue";
import { Datetime } from 'vue-datetime'
import {VuetablePagination, VuetablePaginationInfo, Vuetable} from 'vuetable-2';
import Toasted from 'vue-toasted';
import { Settings } from 'luxon'

Settings.defaultLocale = 'sv'
window._ = require('lodash');
window.Popper = require('popper.js').default;

try {
    window.$ = window.jQuery = require('jquery');
    require('jquery-ui-bundle');
    require('bootstrap');
} catch (e) {}

window.Chart = require('chart.js');
window.moment = require('moment-timezone');

window.moment.locale('sv');
window.moment.tz('Europe/Stockholm');
window.axios = require('axios');


//Global catch for axios errors
window.axios.interceptors.response.use(response => {
    return response;
}, error => {

    if(error.response && error.response.data.exception == 'App\\Exceptions\\PeriodLockedException') {
        Vue.toasted.show(error.response.data.message, {
            position: 'bottom-right',
            duration: 5000,
            type: 'error'
        });
    }

    return Promise.reject(error);
});


window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};


function refreshCsrfToken() {
    window.axios.get('/refresh-csrf-token').then(response => {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf_token;
    }).catch(error => {
        console.error('Error refreshing CSRF token:', error);
    });
}

setInterval(refreshCsrfToken, 20 * 60 * 1000);




import Echo from "laravel-echo"
window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_APP_HOST,
    wsPort: process.env.MIX_PUSHER_APP_PORT,
    wssPort: process.env.MIX_PUSHER_APP_PORT,
    disableStats: true,
    encrypted: process.env.MIX_PUSHER_APP_ENCRYPTED,
    forceTLS: true
});

Vue.prototype.$eventHub = new Vue();

window.events = new Vue();

window.flash = function(message, type) {
    Vue.prototype.$eventHub.$emit('flash', message, type);
};

import VModal from 'vue-js-modal'
import Multiselect from 'vue-multiselect'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import TherapistDashModalAdminTimesList from "./components/Dashboard/Therapist/TherapistDashModalAdminTimesList";

Vue.component('multiselect', Multiselect);

Vue.use(VModal, { dynamic: true });
Vue.use(Datetime)
let ToastOptions = {
    duration: 5000,
    iconPack: 'fontawesome'
};

Vue.use(Toasted, ToastOptions);
Vue.component('datetime', Datetime);
Vue.component('flash', Flash);
Vue.component('reservations', Reservations);
Vue.component('reservations-new', ReservationsNew);
Vue.component('modal-reservations', ModalReservations);
Vue.component('modal-login-or-register', ModalLoginOrRegister);
Vue.component('payment', Payment);
Vue.component('presaleCoupons', PresaleCoupons);

// Communication
Vue.component('communication', Communication);

// Customer dash components
Vue.component('customer-dash', CustomerDash);
Vue.component('customer-create-dash-component', CustomerCreateDashComponent);
Vue.component('customer-dash-coupons', CustomerDashCoupons);
Vue.component('customer-dash-intro', CustomerDashIntro);
Vue.component('customer-dash-locations', CustomerDashLocations);
Vue.component('customer-dash-bookings', CustomerDashBookings);
Vue.component('customer-dash-modal-cancel-booking', CustomerDashModalCancelBooking);
Vue.component('customer-dash-modal-preliminary-info', CustomerDashModalPrelimCancellationInfo);
Vue.component('customer-dash-outro', CustomerDashOutro);
Vue.component('customer-dash-queue', CustomerDashQueue);

// Admin dash components
Vue.component('admin-dash', AdminDash);
Vue.component('admin-create-dash-component', AdminCreateDashComponent);
Vue.component('admin-dash-intro', AdminDashIntro);
Vue.component('admin-dash-coupons', AdminDashCoupons);
Vue.component('admin-dash-occupancy', AdminDashOccupancy);
Vue.component('admin-dash-occupancy-graph', AdminDashOccupancyGraph);
Vue.component('admin-dash-bookings-graph', AdminDashBookingsGraph);
Vue.component('admin-dash-revenue', AdminDashRevenue);
Vue.component('admin-dash-revenue-graph', AdminDashRevenueGraph);
Vue.component('admin-dash-events-panel', AdminDashEventsPanel);
Vue.component('admin-dash-news', AdminDashNews);
Vue.component('vuetable', Vuetable);
Vue.component("vuetable-pagination", VuetablePagination);
Vue.component("vuetable-pagination-info", VuetablePaginationInfo);
// Therapist dash components

Vue.component('therapist-dash', TherapistDash);
Vue.component('therapist-create-dash-component', TherapistCreateDashComponent);
Vue.component('therapist-dash-schedule', TherapistDashSchedule);
Vue.component('therapist-dash-schedule-new', TherapistDashScheduleNew);
Vue.component('therapist-dash-schedules-table', TherapistDashScheduleTable);
Vue.component('therapist-dash-intro', TherapistDashIntro);
Vue.component('therapist-dash-weekly-schedule', TherapistDashWeeklySchedule);
Vue.component('therapist-dash-expenditures-list', TherapistDashExpendituresList);

// Company official dashboard
Vue.component('company-official-dash', CompanyOfficialDash);

// Therapist dashboard modals
Vue.component('therapist-dash-modal-lock', TherapistDashModalLock);
Vue.component('therapist-dash-modal-lock-month', TherapistDashModalLockMonth);
Vue.component('therapist-dash-modal-customer-absent', TherapistDashModalCustomerAbsent);
Vue.component('therapist-dash-modal-customer-present', TherapistDashModalCustomerPresent);
Vue.component('therapist-dash-modal-delete-booking', TherapistDashModalDeleteBooking);
Vue.component('therapist-dash-modal-remove-day', TherapistDashModalRemoveDay);
Vue.component('therapist-dash-modal-add-schedule', TherapistDashModalAddSchedule);
Vue.component('therapist-dash-modal-add-admin-time', TherapistDashModalAddAdministrativeTime);
Vue.component('therapist-dash-admin-time-list', TherapistDashAdminTimeList);
Vue.component('therapist-dash-modal-delete-admin-time', TherapistDashModalDeleteAdminTime);

Vue.component('therapist-dash-modal-manual-booking', TherapistDashModalManualBooking);
Vue.component('therapist-dash-modal-add-expenditure', TherapistDashModalAddExpenditure);
Vue.component('therapist-dash-modal-delete-expenditure', TherapistDashModalDeleteExpenditure);
Vue.component('therapist-dash-reports', TherapistDashReports);

// Therapist availability
Vue.component('therapist-availability', Availability);

Vue.component('simple-weekly-schedule', SimpleWeeklySchedule);
Vue.component('simple-weekly-schedule-day', SimpleWeeklyScheduleDay);
Vue.component('simple-weekly-schedule-post', SimpleWeeklySchedulePost);
Vue.component('simple-weekly-schedule-time', SimpleWeeklyScheduleTime);

Vue.component('admin-schedules-modal-substitute', AdminSchedulesModalSubstitute);
Vue.component('admin-schedules-modal-add-schedule', AdminSchedulesModalAddSchedule);
Vue.component('admin-schedules-modal-remove-day', AdminSchedulesModalRemoveDay);
Vue.component('admin-schedules-modal-customer-absent', AdminSchedulesModalCustomerAbsent);
Vue.component('admin-schedules-modal-customer-present', AdminSchedulesModalCustomerPresent);
Vue.component('admin-schedules-modal-book', AdminSchedulesModalBook);
Vue.component('admin-schedules-modal-absence', AdminSchedulesModalAbsence);
Vue.component('admin-schedules-modal-delete-schedule', AdminSchedulesModalDeleteSchedule);

Vue.component('admin-schedules-batch-modal-change-location', AdminSchedulesBatchModalChangeLocation);
Vue.component('admin-schedules-batch-modal-change-period', AdminSchedulesBatchModalChangePeriod);
Vue.component('admin-schedules-batch-modal-change-therapist', AdminSchedulesBatchModalChangeTherapist);
Vue.component('admin-schedules-batch-modal-change-weekdays', AdminSchedulesBatchModalChangeWeekdays);

Vue.component('absence-form', AbsenceForm);

Vue.component('admin-calendar', AdminCalendar);
Vue.component('admin-schedules', AdminSchedules);
Vue.component('booking', Booking);
Vue.component('booking-new', BookingNew);
Vue.component('double-booking', DoubleBooking);
Vue.component('booking-modal', BookingModal);
Vue.component('prelim-info', CustomerDashModalPrelimCancellationInfo);
Vue.component('calendar', Calendar);
Vue.component('calendar-day', CalendarDay);
Vue.component('transedit', TransEdit);

// Red days
Vue.component('red-day-table', RedDays);
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker);

Vue.prototype.transEdit = window.transEdit;
Vue.prototype.$portalUrl = function(url) {
  if(window.Laravel.portal_therapist_id) {
      let key = 'portal_therapist_id';
      let value = window.Laravel.portal_therapist_id;
      let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      let separator = url.indexOf('?') !== -1 ? "&" : "?";
      if (url.match(re)) {
          return url.replace(re, '$1' + key + "=" + value + '$2');
      }
      else {
          return url + separator + key + "=" + value;
      }
  }

  return url;
};
Vue.config.ignoredElements = ['trix-editor'];

Vue.directive('model-inject', {
    bind: function(el, binding, vnode) {
        el.value = vnode.context[binding.expression];

        vnode.context.injectEvent = new CustomEvent("inject");
        el.addEventListener('inject', function() {
            vnode.context[binding.expression] = el.value;
        });

        // Bind input
        el.addEventListener('input', function() {
            vnode.context[binding.expression] = el.value;
        });
    },
    update: function(el, binding, vnode) {
        el.value = vnode.context[binding.expression];
    }
});

const app = new Vue({
    el: '#app',
});

const errorComposer = (error) => {
    return () => {
        const statusCode = error.response ? error.response.status : null;
        if (statusCode === 404) {
            alert('The requested resource does not exist or has been deleted')
        }

        if (statusCode === 401) {
            alert('Please login to access this resource')
        }
    }
}

window.axios.interceptors.response.use(
    function(response) {
        if(response.data.status === 'ok') {
            if(response.data.message) {
                $.jGrowl(response.data.message, {
                    position: 'top-right',
                    theme: esponse.data.message_type ? `bg-${response.data.message_type}` : 'bg-success'
                });
            }

            return response.data.payload ? response.data.payload : true;
        }

        if(response.data.status === 'error') {
            //alert(`Ett fel har uppstått:\n${response.data.message}`);

            return response;
        }

        return response;
    },
    function (error) {
        error.default = errorComposer(error);

        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
